import { render, staticRenderFns } from "./StoreOwnerFenRun.vue?vue&type=template&id=2793f2e7&scoped=true&"
import script from "./StoreOwnerFenRun.vue?vue&type=script&lang=js&"
export * from "./StoreOwnerFenRun.vue?vue&type=script&lang=js&"
import style0 from "./StoreOwnerFenRun.vue?vue&type=style&index=0&id=2793f2e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2793f2e7",
  null
  
)

export default component.exports